import { message } from 'antd';
import { callApi } from './callApi/rest';


function fetchApi(config) {
	let {
		api,
		service = '/api',
		mockResponse,
		defaultError,
		method,
		success,
		error,
		noPrivilege,
		ignoreNamespaceId,
		ignoreModulePath,
		complete,
		data: commandObject = {},
		isDataReport = false,
		dataType,
		...resetConfig
	} = config || {}
	if (Object.keys(resetConfig).length) {
		console.error('未支持的配置， 如果需要， 请联系前端开发', resetConfig)
	}
	if (isDataReport) {
		let namespaceId = window.$$context && window.$$context.namespaceId;
		if (isDataReport) namespaceId = window.$$dashboardInfo?.namespaceId || namespaceId;
		// 统一增加参数
		const { externalParams, reportType, nodeId } = window.$$dashboardInfo || {};
		if (isDataReport && externalParams) {
			commandObject = Object.assign({ externalParams }, commandObject);
		}
		if (isDataReport && reportType === 'reportCenterDashboard') {
			// const { organizationId, appId } = window.$$context || {};
			const organizationId = window.$$dashboardInfo?.orgId || window.$$context?.organizationId;
			const appId = window.$$dashboardInfo?.appId || window.$$context?.appId;
			commandObject = Object.assign({
				organizationId,
				originId: appId,
				...(nodeId ? { nodeId } : {})
			}, commandObject);
		}
		let headers;
		const dashboardToken = window.$$dashboardInfo && window.$$dashboardInfo.dashboardToken;
		if (isDataReport && dashboardToken) {
			headers = {
				token: dashboardToken,
			};
		}
		return callApi({
			...config,
			service,
			data: {
				namespaceId,
				...commandObject
			},
			...(headers ? { headers } : {}),
			requestJson: dataType === 'json',
		})
	}
	return callApi({
		...config,
		service,
		requestJson: dataType === 'json',
	})
}

export default fetchApi;
